var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 2.41699C7.84192 2.41699 2.4165 7.84241 2.4165 14.5003C2.4165 21.1582 7.84192 26.5837 14.4998 26.5837C21.1578 26.5837 26.5832 21.1582 26.5832 14.5003C26.5832 7.84241 21.1578 2.41699 14.4998 2.41699ZM19.3332 15.4066H15.4061V19.3337C15.4061 19.8291 14.9953 20.2399 14.4998 20.2399C14.0044 20.2399 13.5936 19.8291 13.5936 19.3337V15.4066H9.6665C9.17109 15.4066 8.76025 14.9957 8.76025 14.5003C8.76025 14.0049 9.17109 13.5941 9.6665 13.5941H13.5936V9.66699C13.5936 9.17158 14.0044 8.76074 14.4998 8.76074C14.9953 8.76074 15.4061 9.17158 15.4061 9.66699V13.5941H19.3332C19.8286 13.5941 20.2394 14.0049 20.2394 14.5003C20.2394 14.9957 19.8286 15.4066 19.3332 15.4066Z",
    fill: "#CA9688"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRed);
export default __webpack_public_path__ + "static/media/addRed.4936e53b3520a1e14fe43843397aee91.svg";
export { ForwardRef as ReactComponent };